import { config } from "zod";

config({ jitless: true });
